import { render, staticRenderFns } from "./SubgroupRules.vue?vue&type=template&id=f3c9cbb8&scoped=true"
import script from "./SubgroupRules.vue?vue&type=script&lang=js"
export * from "./SubgroupRules.vue?vue&type=script&lang=js"
import style0 from "./SubgroupRules.vue?vue&type=style&index=0&id=f3c9cbb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c9cbb8",
  null
  
)

export default component.exports